import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

const MonthPicker = DatePicker.MonthPicker;
const YearPicker = DatePicker.YearPicker;

function getTips(type) {
    switch (type) {
        default:
            break;
        case "year":
            return [getLabel("81716", "上一年"), getLabel("81718", "下一年")];
        case "month":
            return [getLabel("27347", "上个月"), getLabel("27348", "下个月")];
        case "week":
            return [getLabel("26789", "上周"), getLabel("83132", "下周")];
        case "day":
            return [getLabel("385893", "上一天"), getLabel("385894", "下一天")];
    }
}

export default class ResourceDatePickerArrow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            togglePicker: false,
            date: props.date || props.value,
            dateLabel: this.parseDate(props.date || props.value)
        };
        this.onChange = this.onChange.bind(this);
        this.togglePicker = this.togglePicker.bind(this);
        this.parseDate = this.parseDate.bind(this);
        this.changeValue = this.changeValue.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            date: nextProps.date || nextProps.value,
            dateLabel: this.parseDate(
                nextProps.date || nextProps.value,
                nextProps.type
            )
        });
    }

    formatOfZero = value => {
        // 增加 年月日 是否带0的处理
        const { formatWithZero = true } = this.props;
        if (!formatWithZero) {
            return value.replace(/\b(0+)/gi, "");
        }
        return value;
    };

    parseDate(value, type = this.props.type, C_N = this.props.C_N) {
        if (!value) return getLabel("27938", "请选择日期");
        let curMoment = value._isAMomentObject ? value : moment(value);
        let yearFormat = getLabel("386427", "YYYY年");
        let monthDayFormat = getLabel("386428", "MM月DD日");
        let dateFormat = getLabel("386429", "YYYY年MM月DD日");
        let monthFormat = getLabel("386679", "YYYY年MM月");
        let curMomentCopy = moment(curMoment);
        const weekFirstDay = 1;
        let isC_N = C_N ? true : false;
        let str = "";
        switch (type) {
            case "year":
                str = curMoment.format(yearFormat);
                break;
            case "quarter":
                str =
                    curMoment.format(yearFormat) + "第" + curMoment.quarter() + "季度";
                break;
            case "month":
                str = curMoment.format(monthFormat);
                break;
            case "week": {
                if (this.props.weekstart === "3") { // weekstart=3, 即取今天开始的七天
                    let curDay = curMomentCopy.day()
                    str =
                        curMomentCopy.day(curDay).format(dateFormat) +
                        "~" +
                        curMomentCopy.day(curDay + 6).format(monthDayFormat);
                } else {
                    if (isC_N) {
                        let curDay = curMomentCopy.day();
                        curMomentCopy.day(weekFirstDay);
                        let weekFirstDayNum = curMomentCopy.day();
                        if (weekFirstDayNum <= curDay) {
                            str =
                                curMomentCopy.format(dateFormat) +
                                "~" +
                                curMomentCopy.day(weekFirstDay + 6).format(monthDayFormat);
                        } else {
                            str =
                                curMomentCopy.day(weekFirstDay - 7).format(dateFormat) +
                                "~" +
                                curMomentCopy.day(weekFirstDay + 6).format(monthDayFormat);
                        }
                    } else {
                        str =
                            curMoment.day(0).format(dateFormat) +
                            "~" +
                            curMoment.day(6).format(monthDayFormat);
                    }
                }
                break;
            }
            case "day":
            default:
                str = curMoment.format(dateFormat);
        }
        return this.formatOfZero(str);
    }

    onChange(date, dateStr) {
        if (!date) date = new Date();
        this.setState({
            date: date,
            dateLabel: this.parseDate(date)
        });
        this.togglePicker();
        this.callback(date);
    }
    togglePicker() {
        this.setState({
            togglePicker: !this.state.togglePicker
        });
    }
    changeValue(diff) {
        let curMoment = moment(this.state.date);
        switch (this.props.type) {
            default:
                break;
            case "year": {
                let year = curMoment.year();
                curMoment.year(year + diff);
                break;
            }
            case "quarter":
                let month = curMoment.month();
                curMoment.month(month + diff * 3);
                break;
            case "month": {
                let month = curMoment.month();
                curMoment.month(month + diff);
                break;
            }
            case "week": {
                let dayOfYear = curMoment.dayOfYear();
                curMoment.dayOfYear(dayOfYear + diff * 7);
                break;
            }
            case "day": {
                let dayOfYear = curMoment.dayOfYear();
                curMoment.dayOfYear(dayOfYear + diff);
                break;
            }
        }
        this.setState({
            date: curMoment,
            dateLabel: this.parseDate(curMoment)
        });
        this.callback(curMoment);
    }

    callback(value) {
        if (!this.props.onChange) return;
        let dateRange = this.getDateRange(value);
        this.props.onChange(value, dateRange);
    }

    getDateRange(value) {
        let curMoment = moment(value);
        let date;
        switch (this.props.type) {
            case "year":
                date = curMoment.format("YYYY");
                break;
            case "quarter":
                date = curMoment.format("YYYY-MM");
                break;
            case "month":
                date = curMoment.format("YYYY-MM");
                break;
            case "week":
                date = curMoment.format("YYYY-MM-DD");
                break;
            case "day":
                date = curMoment.format("YYYY-MM-DD");
                break;
            default:
                date = curMoment.format("YYYY-MM-DD");
                break;
        }
        return this.formatOfZero(date);
    }

    renderPicker() {
        let date = this.state.date,
            defaultValue = moment.isMoment(date) ? date.toDate() : date;
        const { formatWithZero = true, ecId } = this.props;
        let pickerProps = {
            onChange: this.onChange,
            open: this.state.togglePicker,
            defaultValue: defaultValue,
            value: defaultValue,
            toggleOpen: this.togglePicker,
            formatWithZero // feat: 格式化 年月日 是否带0处理
        };
        const { type, datePickerProps } = this.props;
        // -----用于WeaDateSwitch组件支持配置antd DatePicker参数------
        if (datePickerProps) {
            pickerProps = {
                ...pickerProps,
                ...datePickerProps
            };
        }
        // --------------------------------------------------------
        if (type == "month") {
            return (
                <MonthPicker {...pickerProps} ecId={`${ecId}_MonthPicker@lgk4iu`} />
            );
        }
        if (type == "year") {
            return (
                <YearPicker
                    {...pickerProps}
                    ecId={`${ecId}_YearPicker@cx3xn9`}
                    className="wea-year-picker"
                />
            );
        }
        if (type == "quarter") {
            return (
                <MonthPicker {...pickerProps} ecId={`${ecId}_MonthPicker@v0il0v`} />
            );
        }
        return <DatePicker {...pickerProps} ecId={`${ecId}_DatePicker@3hht9m`} />;
    }
    render() {
        let { date } = this.state,
            defaultValue = moment.isMoment(date) ? date.toDate() : date;
        const { label, type, style, ecId } = this.props;
        const tips = getTips(type) || [];
        return (
            <div
                className={`wea-date-picker-arrow ${this.props.className}`}
                style={style}
            >
                <span
                    ecId={`${ecId}_span@ep8i01`}
                    className="icon-coms-Browse-box-delete"
                    onClick={this.changeValue.bind(this, -1)}
                    title={tips[0]}
                />
                <span
                    ecId={`${ecId}_span@ezufk3`}
                    onClick={this.togglePicker}
                    className="label"
                >
                    <span
                        style={{
                            opacity: 0,
                            width: 0,
                            position: "absolute",
                            overflow: "hidden"
                        }}
                    >
                        {this.renderPicker()}
                    </span>
                    {label ? label : this.state.dateLabel}
                </span>
                <span
                    ecId={`${ecId}_span@o24r4n`}
                    className="icon-coms-Browse-box-Add-to"
                    onClick={this.changeValue.bind(this, 1)}
                    title={tips[1]}
                />
            </div>
        );
    }
}
ResourceDatePickerArrow.defaultProps = {
    type: "date"
};
ResourceDatePickerArrow.propTypes = {
    type: React.PropTypes.string, //month为月选择器，week为周选择器，其它为日选择器
    onChange: React.PropTypes.func, //时间发生变化的回调,会返回选择的日期与类型对应的日期范围
    date: React.PropTypes.any, //当前日期，支持jsDate,字符串
    className: React.PropTypes.string //附加的样式名
};




// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/view-resource/ResourceDateSwitch/ResourceDatePickerArrow.js